<template>
	<div class="microsoft-callback min-height-full d-flex align-center">
		<v-container fluid class="pa-4 pa-sm-6">
			<v-row justify="center">
				<v-col cols="12" sm="10" md="6" lg="4">
					<v-card class="elevation-0 text-center pa-6 pa-sm-8 pa-md-10">
						<h1 class="microsoft-callback__title mb-6 mb-sm-8">Connexion Microsoft</h1>
						<v-progress-circular :size="spinnerSize" :width="spinnerWidth" color="primary" indeterminate />
						<p class="microsoft-callback__message mt-6 mb-0">Connexion en cours…</p>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</div>
</template>

<script>
import { handleMicrosoftRedirect } from '../../utils/microsoftAuth';
import { checkShouldRedirectToTestPage } from '../../utils/login';

export default {
	name: 'MicrosoftCallback',
	computed: {
		spinnerSize() {
			return this.$vuetify.breakpoint.xsOnly ? 40 : 50;
		},
		spinnerWidth() {
			return this.$vuetify.breakpoint.xsOnly ? 3 : 4;
		},
	},
	async created() {
		try {
			const idToken = await handleMicrosoftRedirect();
			if (!idToken) {
				this.$router.push({ name: 'Login' });
				return;
			}

			const res = await this.$http.post('/api/auth/microsoft', { idToken });

			localStorage.setItem('token', res.data.token);

			const canContinue = await checkShouldRedirectToTestPage(
				() => this.$router.push({ name: 'TestHomePage' }),
				() => this.$router.push({ name: 'Login', query: { error: 'manager_no_formation' } })
			);
			if (canContinue === false) return;

			this.$router.push('/dashboard');
		} catch (error) {
			console.error('[Microsoft Auth] Callback error:', error);

			const responsePayload = error.response;
			const status = responsePayload && responsePayload.status;
			const data = responsePayload && responsePayload.data;
			const message = (data && data.message) || 'Une erreur est survenue lors de la connexion Microsoft';

			if (status === 404) {
				this.$router.push({ name: 'Login', query: { error: message } });
				return;
			}

			this.$router.push({ name: 'Login', query: { error: message } });
		}
	},
};
</script>

<style scoped lang="scss">
.microsoft-callback {
	width: 100%;

	&__title {
		font-size: clamp(1.25rem, 4vw, 1.75rem);
		line-height: 1.3;
		word-break: break-word;
	}

	&__message {
		font-size: clamp(0.875rem, 2.5vw, 1rem);
		color: rgba(0, 0, 0, 0.6);
	}
}
</style>
